import { tWithKeyAttr as t } from "../../../i18nHelper";
import changeAvatarPopup from "./changeAvatarPopup.module.css";
import React, { useState } from "react";
import { IPopupWithoutProps } from "../../../types/types";
import ChangePasswordSuccessPopup from "../changePasswordSuccessPopup/changePasswordSuccessPopup";
import { useFormik } from "formik";
import loginStyles from "../../../pages/login/login.module.css";
import {
  useDeleteUserAvatarMutation,
  useLazyGetUserQuery,
  useUploadUserAvatarMutation,
} from "../../../services/api/user.api";
import { useAppDispatch, useAppSelector } from "../../../services/hooks";
import { userSelector } from "../../../services/selectors/user.selectors";
import { setUserAvatar } from "../../../services/slices/auth.slice";
import Modal from "../modal/Modal";
import ErrorPopup from "../errorPopup/errorPopup";
import uploadIcon from "../../../images/upload_icon.svg"

function ChangeAvatarPopup({ onClose }: IPopupWithoutProps) {

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openErrorModal, setOpenErrorModal] = useState<boolean>(false);
  const [image, setImage] = useState<File | null>(null);
  const [imageURL, setImageURL] = useState<string | null>(null);

  const [deleteUserAvatar, { isError: isErrorDeleting }] = useDeleteUserAvatarMutation();
  const [uploadImage, { isError }] = useUploadUserAvatarMutation();
  const [getUser] = useLazyGetUserQuery();
  const [openDeleteSuccessPopup, setOpenDeleteSuccessPopup] = useState(false);

  const dispatch = useAppDispatch();
  const user = useAppSelector(userSelector);
  const hasAvatar = Boolean(user.avatar);


  const handleSubmit = async () => {
    try {
      if (image) {
        const formData = new FormData();
        formData.append("avatar", image);
        const response = await uploadImage({
          form: formData,
          guid: user.guid,
        });
        if ("data" in response && response.data) {
          dispatch(setUserAvatar(response.data.avatar));
          setOpenModal(true);
          await getUser().unwrap();
        } else {
          setOpenErrorModal(true);
        }
      }
    } catch (error) {
      console.error(t("SOMETHING_WENT_WRONG_TRY_AGAIN_LATER"), error);
      setOpenErrorModal(true);
    }
  };

  const handleImageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      setImage(file);
      formik.setFieldValue("avatar", file);
      formik.setFieldValue("avatarName", file.name);
      const url = URL.createObjectURL(file); // Create a URL for the file
      setImageURL(url);
    }
  };

  const formik = useFormik({
    initialValues: {
      avatar: "",
      avatarName: "",
    },
    onSubmit: () => {
      handleSubmit();
    },
  });
  const handleDeleteAvatar = async () => {
    const confirmed = window.confirm(t('CHANGE_AVATAR_DELETE_CONFIRM'));
    if (!confirmed) return;

    try {
      const response = await deleteUserAvatar({
        guid: user.guid,
      });

      if ("data" in response && response.data) {
        formik.setFieldValue("avatar", "");
        formik.setFieldValue("avatarName", "");
        setImage(null);
        setImageURL(null);
        dispatch(setUserAvatar(null));
        await getUser().unwrap();
        setOpenDeleteSuccessPopup(true);

      } else {
        setOpenErrorModal(true);
      }
    } catch (error) {
      console.error(t("CHANGE_AVATAR_DELETE_ERROR"), error);
      setOpenErrorModal(true);
    }
  };

  return openErrorModal ?
    (<Modal onClose={() => setOpenErrorModal(false)}>
      <ErrorPopup onClose={() => setOpenErrorModal(false)} />
    </Modal>
    ) : openDeleteSuccessPopup ? (
      <Modal onClose={() => setOpenDeleteSuccessPopup(false)}>
        <ChangePasswordSuccessPopup onClose={onClose} type="delete-avatar" />
      </Modal>
    ) : openModal ? (
      <ChangePasswordSuccessPopup onClose={onClose} type="avatar" />
    ) : (
      <article className={changeAvatarPopup.popup}>
        <div className={changeAvatarPopup.popup__content}>
          <h2 className={changeAvatarPopup.popup__title}>
          {t("CHANGE_AVATAR_TITLE")}
          </h2>
          <form
            id="updateAvatar"
            onSubmit={formik.handleSubmit}
            className={changeAvatarPopup.popup__form}
          >
            <div className={changeAvatarPopup.file_input_wrapper}>
              {(formik.values.avatar && imageURL) && (
                <img
                  src={imageURL}
                  alt="Avatar Preview"
                  className={`w-full h-full object-cover rounded-full border border-gray-300 ${changeAvatarPopup.popup__img}`}
                />
              )}
              <label
                htmlFor={"avatar"}
                // className={changePasswordPopupStyles.popup__label}
                // className="px-4 py-2 bg-purple-600 text-white text-sm font-medium rounded-lg cursor-pointer hover:bg-purple-700 focus:ring-2 focus:ring-purple-500 focus:outline-none"
                className={changeAvatarPopup.popup__label}
              >
                <img
                  src={uploadIcon}
                  alt={t("CHANGE_AVATAR_UPLOAD_ICON_ALT")}
                  className={changeAvatarPopup.popup__img_upload}
                />
                <p>{t("CHANGE_AVATAR_UPLOAD_LABEL")}</p>
              </label>
              <input
                type="file"
                name={"avatar"}
                id={"avatar"}
                // value={formik.values.avatar}
                accept="image/*"
                onChange={(e) => handleImageChange(e)}
                onBlur={formik.handleBlur}
                className={changeAvatarPopup.popup__input_hiden}

              />
            </div>
            {formik.errors.avatar && (
              <p className={`${loginStyles.login__invalid_message}`}>
                {t(formik.errors.avatar)}
              </p>
            )}
            {(isError || isErrorDeleting) && (
              <p className={`${loginStyles.login__invalid_message}`}>
                {t("SOMETHING_WENT_WRONG_TRY_AGAIN_LATER")}
              </p>
            )}
            <button
              type="submit"
              form="updateAvatar"
              disabled={formik.isSubmitting || !formik.isValid || !image}
              className={`button hover ${changeAvatarPopup.popup__submitBtn} ${formik.isSubmitting || (!formik.isValid ||
                !image) ? changeAvatarPopup.popup__submitBtn_disabled : ""}`}

            >
          {t("CHANGE_AVATAR_UPDATE_BUTTON")}
            </button>
            <button
              type="button"
              onClick={handleDeleteAvatar}
              disabled={!hasAvatar}
              className={`button hover ${changeAvatarPopup.popup__submitBtn} ${!hasAvatar ? changeAvatarPopup.popup__submitBtn_disabled : ""}`}
            >
               {t("CHANGE_AVATAR_DELETE_BUTTON")}
            </button>
          </form>
        </div>
      </article>
    );
}

export default ChangeAvatarPopup;
